import "./styles/keyframes.css"
import React from "react"
import styled from "styled-components"

import Loader from "./Loader"
import HyperDiv from "../HyperDiv/HyperDiv"
import Whitespace from "../Whitespace"
import LoadingText from "./LoadingText"
import LoaderWithText from "./LoaderWithText"

interface Props {
	active?: boolean
}

const GlobalOverlayLoader = ({ active }: Props) => {
	if (!active) return <></>

	return (
		<OverlayBase>
			<HyperDiv centered height="inherit" direction="column">
				<LoaderWithText />
			</HyperDiv>
		</OverlayBase>
	)
}

export default GlobalOverlayLoader

const OverlayBase = styled.div`
	background-color: rgba(255, 255, 255, 0.6);
	backdrop-filter: blur(0.69px);
	width: 100vw;
	max-width: 100%;
	height: 100vh;
	max-height: 100%;
	z-index: 10000;

	position: fixed;

	overflow-x: hidden;
	overflow-y: hidden;
`
